import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import type { ChangeEvent } from 'react';

interface CurrencyFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  helperText?: string;
  placeholder?: string;
}

export default function CurrencyField({
  label,
  value,
  onChange,
  required,
  helperText,
  placeholder,
}: CurrencyFieldProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\D/g, '');
    if (!raw) {
      onChange('');
      return;
    }
    const cents = parseInt(raw, 10);
    const formatted = (cents / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    onChange(formatted);
  };

  return (
    <TextField
      fullWidth
      size="small"
      label={label}
      value={value}
      onChange={handleChange}
      placeholder={placeholder ?? '0,00'}
      required={required}
      helperText={helperText}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">R$</InputAdornment>
        ),
      }}
      inputProps={{ inputMode: 'numeric' }}
    />
  );
}
